export const comments_5187254 = {"data":{"data":[],"links":{}}}